var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _require = require('crypto'),
    pbkdf2 = _require.pbkdf2Sync,
    randomBytes = _require.randomBytes;

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var base64url = require('../help/base64url');

var SALT_LENGTH = 16;
var NULL_BUFFER = Buffer.alloc(1, 0);

var concatSalt = function concatSalt(alg, p2s) {
  return Buffer.concat([Buffer.from(alg, 'utf8'), NULL_BUFFER, p2s]);
};

var wrapKey = function wrapKey(keylen, sha, concat, wrap, _ref, payload) {
  var keyObject = _ref[KEYOBJECT];
  // Note that if password-based encryption is used for multiple
  // recipients, it is expected that each recipient use different values
  // for the PBES2 parameters "p2s" and "p2c".
  // here we generate p2c between 2048 and 4096 and random p2s
  var p2c = Math.floor(Math.random() * 2049 + 2048);
  var p2s = randomBytes(SALT_LENGTH);
  var salt = concat(p2s);
  var derivedKey = pbkdf2(keyObject.export(), salt, p2c, keylen, sha);
  var result = wrap(_defineProperty({}, KEYOBJECT, derivedKey), payload);
  result.header = result.header || {};
  Object.assign(result.header, {
    p2c: p2c,
    p2s: base64url.encodeBuffer(p2s)
  });
  return result;
};

var unwrapKey = function unwrapKey(keylen, sha, concat, unwrap, _ref2, payload, header) {
  var keyObject = _ref2[KEYOBJECT];
  var p2s = header.p2s,
      p2c = header.p2c;
  var salt = concat(p2s);
  var derivedKey = pbkdf2(keyObject.export(), salt, p2c, keylen, sha);
  return unwrap(_defineProperty({}, KEYOBJECT, derivedKey), payload, header);
};

module.exports = function (JWA, JWK) {
  ['PBES2-HS256+A128KW', 'PBES2-HS384+A192KW', 'PBES2-HS512+A256KW'].forEach(function (jwaAlg) {
    var kw = jwaAlg.substr(-6);
    var kwWrap = JWA.keyManagementEncrypt.get(kw);
    var kwUnwrap = JWA.keyManagementDecrypt.get(kw);
    var keylen = parseInt(jwaAlg.substr(13, 3), 10) / 8;
    var sha = "sha".concat(jwaAlg.substr(8, 3));

    if (kwWrap && kwUnwrap) {
      JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, keylen, sha, concatSalt.bind(undefined, jwaAlg), kwWrap));
      JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, keylen, sha, concatSalt.bind(undefined, jwaAlg), kwUnwrap));

      JWK.oct.deriveKey[jwaAlg] = function (key) {
        return key.use === 'enc' || key.use === undefined;
      };
    }
  });
};